import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    padding: 6px 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Number = styled.div`
    position: relative;
    font-size: ${({ fontSize }) => fontSize || '18px'};
    color: ${({ color }) => color || '#F9F9F9'};
    font-weight: bold;
    align-items: center;
`;

export const Description = styled.span`
    font-size: 12px;
    color: ${({ color }) => color || '#B5B5B5'};
    text-align: center;
`;

export const Image = styled.img`
    position: absolute;
    height: 100%;
    width: ${({width}) => `${width}px`};
    margin-left: 8px;
`;
